import CodeIcon from '@material-ui/icons/Code';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import { FloatingSidebarMenu } from './FloatingSidebarMenu';
import type { FloatingSidebarItem } from './FloatingSidebarMenu';

const DOCS_LINKS: FloatingSidebarItem[] = [
  {
    title: 'Ingeniería',
    description: 'Estándares y guías',
    icon: MenuBookIcon,
    to: '/docs/engineering',
    activePaths: [
      '/docs/engineering',
      '/docs/default/component/spin-engineering-docs',
    ],
  },
  {
    title: 'Spin CLI',
    description: 'Spin Command Line Interface',
    icon: CodeIcon,
    to: '/docs/cli',
    activePaths: ['/docs/cli', '/docs/default/component/spin-engineering-cli'],
  },
  {
    title: 'Libs',
    description: 'Documentación de librerías',
    icon: LibraryBooksIcon,
    to: '/docs/libs',
    activePaths: ['/docs/libs'],
  },
];

export const DocsSidebarMenu = () => (
  <FloatingSidebarMenu
    id="docs"
    title="Docs"
    icon={LibraryBooksIcon}
    items={DOCS_LINKS}
    activePaths={['/docs']}
  />
);
